import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Flex, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { RememberMeCheckbox } from '../RememberMeCheckbox/index.js';
import { LoginButton } from '../LoginButton/index.js';
import { ForgotPasswordLink } from '../ForgotPasswordLink/ForgotPasswordLink.js';
import { LoginEmailInput, LoginPasswordInput, } from '../Inputs/index.js';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { credentialsSelector, isLoadingSelector, loginRequestThunk, updateEmailError, updateEmailErrorMessage, updatePasswordError, updatePasswordErrorMessage, } from '../../loginSlice.js';
import { validatePassword } from '../../../../helpers/validatePassword.js';
import { validateEmail } from '../../../../helpers/validateEmail.js';
import { trackButtonClick, trackFormFieldError } from '../../../../tracking/index.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../../../TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { selectActiveForm } from '../../../../core/navigation/navigationSlice.js';
import { isTwoStep } from '../../../../tracking/helpers/constants.js';
export const LoginWithEmailForm = () => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(isLoadingSelector);
    const { email, password } = useAppSelector(credentialsSelector);
    const activeFormType = useAppSelector(selectActiveForm);
    const componentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const { t } = useTranslation();
    const sendFormFieldErrorTracking = (formFieldErrors) => {
        dispatch(sendGlobalTrackingThunk(trackFormFieldError, {
            formFieldErrors,
            ...(isTwoStep(activeFormType) && {
                componentState,
            }),
        }));
    };
    const loginButtonOnClick = async () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'loginWithEmailPassword',
            ...(isTwoStep(activeFormType) && {
                componentState,
            }),
        }));
        const validEmail = validateEmail(email.value);
        const validPassword = validatePassword(password.value);
        if (!validEmail) {
            if (validPassword) {
                sendFormFieldErrorTracking('emailAddressNotValid');
            }
            else {
                sendFormFieldErrorTracking('bothFieldsNotValid');
            }
            dispatch(updateEmailError(!validEmail));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
        }
        if (!validPassword) {
            if (validEmail) {
                sendFormFieldErrorTracking('passwordNotValid');
            }
            dispatch(updatePasswordError(!validPassword));
            dispatch(updatePasswordErrorMessage(t('loginregistration.password.validation.error')));
        }
        if (validEmail && validPassword) {
            dispatch(loginRequestThunk());
        }
        return;
    };
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], children: [_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceL'], children: [_jsx(LoginEmailInput, {}), _jsx(LoginPasswordInput, {})] }), _jsxs(Flex, { flxItems: 'center', flxJustify: 'space-between', pb: ['spaceS'], children: [_jsx(RememberMeCheckbox, {}), _jsx(ForgotPasswordLink, {})] }), _jsx(LoginButton, { isLoading: isLoading, onClick: loginButtonOnClick })] }));
};
//# sourceMappingURL=LoginWithEmailForm.js.map